import { FreightPricingPortalError } from "@/types/error/FreightPricingPortalError";
import { SeparatorLine } from "@stenajs-webui/core";
import { CardBody } from "@stenajs-webui/elements";
import { StandardTable } from "@stenajs-webui/grid";
import * as React from "react";
import { useMemo, useState } from "react";
import { agreementDocumentsTableConfig } from "../config/AgreementDocumentsTableConfig";
import { AgreementDocumentsTableItem } from "../models";

interface Props {
  agreementDocuments: AgreementDocumentsTableItem[] | undefined;
}

export const AgreementDocumentsContent: React.FC<Props> = ({
  agreementDocuments,
}) => {
  const [downloadError, setDownloadError] =
    useState<FreightPricingPortalError>();
  const [deletedListItems, setDeletedListItems] = useState<Array<String>>([]);

  const config = useMemo(() => {
    return agreementDocumentsTableConfig(
      downloadError,
      setDownloadError,
      setDeletedListItems
    );
  }, [downloadError, setDownloadError, setDeletedListItems]);

  const items = agreementDocuments?.filter((d) => {
    return !deletedListItems.includes(d.id);
  });

  return (
    <CardBody>
      <StandardTable
        items={items}
        config={config}
        loading={false}
        noItemsLabel={"No documents found."}
      />
      <SeparatorLine />
    </CardBody>
  );
};
